import { getEnv } from '@ctct/ctct-helpers';

type Envs = '.l1.' | '.s1.' | '.';

class Environments {
  public getSecurePayEnv() {
    const env = this.getEnv();

    switch (env) {
      case '.l1.':
        return 'qa.';
      case '.s1.':
        return 'stage.';
      case '.':
      default:
        return '';
    }
  }

  public getEnv(): Envs {
    return getEnv();
  }

  public isL1() {
    return this.getEnv() === '.l1.';
  }

  public isS1() {
    return this.getEnv() === '.s1.';
  }

  public isProd() {
    return this.getEnv() === '.';
  }

  public isSecure() {
    const secureDomains = [
      'secure.localhost.l1.constantcontact.com',
      'secure.l1.constantcontact.com',
      'secure.s1.constantcontact.com',
      'secure.constantcontact.com',
    ];

    const { hostname } = window.location;

    return secureDomains.some((domain) => hostname === domain);
  }

  public isSecureL1() {
    return this.isSecure() && this.isL1();
  }

  public isSecureS1() {
    return this.isSecure() && this.isS1();
  }

  public isSecureProd() {
    return this.isSecure() && this.isProd();
  }
}

export const envs = new Environments();
